<section class="w-full px-15">
    <div class="w-full flex justify-center items-center mb-10">
        <div class="w-full flex flex-row p-10 justify-between items-center">
            <div class="flex flex-col">
                @if (view.site && view.site.profile && view.site.profile.heading) {
                    @switch (view.site.profile.heading.position) {
                        @case (1) {
                            <app-heading_section-type01 [options]="{heading:'News & Blog',title:'Book a Hotel Within Your Budget',image:'', description:'',swooshAlign: {'margin':''} }" ></app-heading_section-type01>
                            }
                        @case (2) {
                            <app-heading_section-type01 [options]="{heading:'News & Blog',title:'Book a Hotel Within Your Budget',image:'assets/xltravel/swoosh-01.svg', description:''}" ></app-heading_section-type01>
                        }
                    }
                }
            </div>
            <div class="flex flex-row">
                <div class="group">
                    <div class="flex items-center justify-center mr-5 w-15 h-15 cursor-pointer bg-primary-100 group-hover:bg-primary-500 transition ease-out duration-500 border-none rounded-full">
                        <mat-icon class="icon-size-6 text-primary-500 group-hover:text-primary-100 transition ease-out duration-500" [svgIcon]="'feather:arrow-left'"></mat-icon>
                    </div>
                </div>
                <div class="group">
                    <div class="flex items-center justify-center w-15 h-15 cursor-pointer bg-primary-100 group-hover:bg-primary-500 transition ease-out duration-500 border-none rounded-full">
                        <mat-icon class="icon-size-6 text-primary-500 group-hover:text-primary-100 transition ease-out duration-500" [svgIcon]="'feather:arrow-right'"></mat-icon>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div>
        <div id="news_left">
            <div class="w-full flex mb-10 justify-between">
                <fuse-card class="flex flex-col h-[640px] max-w-lg w-full bg-white dark:bg-gray-700 m-2">
                    <div class="pl-4 pr-4 pt-4">
                        <img class="object-cover h-72 w-full" src="https://images.pexels.com/photos/7968580/pexels-photo-7968580.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="article image">
                    </div>
                    <div class="flex flex-row mt-2">
                        <div class="p-1 mt-2 pl-4 pr-4">
                            <img class="object-cover h-12 w-12" src="https://images.pexels.com/photos/7968580/pexels-photo-7968580.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="article image">
                        </div>
                        <div class="flex flex-col p-1 mt-2">
                            <div class="flex items-center mr-4">
                                <mat-icon class="text-primary-500 mr-2" [svgIcon]="'mat_outline:person_outline'"></mat-icon>
                                <p class="text-md text-gray-800">
                                    By Alex Micheal
                                </p>
                            </div>
                            <div class="flex items-center">
                                <mat-icon class="text-primary-500 mr-2" [svgIcon]="
                                        'heroicons_outline:calendar-days'
                                    "></mat-icon>
                                <p class="text-md text-gray-800">
                                    Jun 15, 2023
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="mt-4 px-4 mb-5">
                        <h3 class="text-3xl font-semibold font-primary mt-1">
                            The Ultimate Guide to Traveling When You Have No
                            Money
                        </h3>
                        <p class="mt-3 text-gray-500">
                            Embark on a budget-friendly adventure is not just
                            about saving money, It's about maximizing your
                            experiences. By adopting a thrifty mindset
                        </p>
                    </div>
                    <hr class="ml-5 mr-5">
                    <div class="w-full relative flex justify-start items-center flex-wrap gap-5 mt-3 px-4">
                        <button class="group py-2 px-2 uppercase hover:text-primary-500 font-semibold">
                            <span class="group-hover:text-primary-500 transition ease-out duration-500">
                            </span
                            >
                            Read More
                            <mat-icon class="icon-size-5 text-black ml-2 pt-2 group-hover:text-primary-500" [svgIcon]="'feather:arrow-right'"></mat-icon>
                        </button>
                    </div>
                </fuse-card>
                <fuse-card class="flex flex-col h-[640px] max-w-lg w-full bg-white dark:bg-gray-700 m-2">
                    <div class="pl-4 pr-4 pt-4">
                        <img class="object-cover h-72 w-full" src="https://images.pexels.com/photos/7968580/pexels-photo-7968580.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="article image">
                    </div>
                    <div class="flex flex-row mt-2">
                        <div class="p-1 mt-2 pl-4 pr-4">
                            <img class="object-cover h-12 w-12" src="https://images.pexels.com/photos/7968580/pexels-photo-7968580.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="article image">
                        </div>
                        <div class="flex flex-col p-1 mt-2">
                            <div class="flex items-center mr-4">
                                <mat-icon class="text-primary-500 mr-2" [svgIcon]="'mat_outline:person_outline'"></mat-icon>
                                <p class="text-md text-gray-800">
                                    By Alex Micheal
                                </p>
                            </div>
                            <div class="flex items-center">
                                <mat-icon class="text-primary-500 mr-2" [svgIcon]="
                                        'heroicons_outline:calendar-days'
                                    "></mat-icon>
                                <p class="text-md text-gray-800">
                                    Jun 15, 2023
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="mt-4 px-4 mb-5">
                        <h3 class="text-3xl font-semibold font-primary mt-1">
                            The Ultimate Guide to Traveling When You Have No
                            Money
                        </h3>
                        <p class="mt-3 text-gray-500">
                            Embark on a budget-friendly adventure is not just
                            about saving money, It's about maximizing your
                            experiences. By adopting a thrifty mindset
                        </p>
                    </div>
                    <hr class="ml-5 mr-5">
                    <div class="w-full relative flex justify-start items-center flex-wrap gap-5 mt-3 px-4">
                        <button class="group py-2 px-2 uppercase hover:text-primary-500 font-semibold">
                            <span class="group-hover:text-primary-500 transition ease-out duration-500">
                            </span
                            >
                            Read More
                            <mat-icon class="icon-size-5 text-black ml-2 pt-2 group-hover:text-primary-500" [svgIcon]="'feather:arrow-right'"></mat-icon>
                        </button>
                    </div>
                </fuse-card>
                <fuse-card class="flex flex-col h-[640px] max-w-lg w-full bg-white dark:bg-gray-700 m-2">
                    <div class="pl-4 pr-4 pt-4">
                        <img class="object-cover h-72 w-full" src="https://images.pexels.com/photos/7968580/pexels-photo-7968580.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="article image">
                    </div>
                    <div class="flex flex-row mt-2">
                        <div class="p-1 mt-2 pl-4 pr-4">
                            <img class="object-cover h-12 w-12" src="https://images.pexels.com/photos/7968580/pexels-photo-7968580.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="article image">
                        </div>
                        <div class="flex flex-col p-1 mt-2">
                            <div class="flex items-center mr-4">
                                <mat-icon class="text-primary-500 mr-2" [svgIcon]="'mat_outline:person_outline'"></mat-icon>
                                <p class="text-md text-gray-800">
                                    By Alex Micheal
                                </p>
                            </div>
                            <div class="flex items-center">
                                <mat-icon class="text-primary-500 mr-2" [svgIcon]="
                                        'heroicons_outline:calendar-days'
                                    "></mat-icon>
                                <p class="text-md text-gray-800">
                                    Jun 15, 2023
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="mt-4 px-4 mb-5">
                        <h3 class="text-3xl font-semibold font-primary mt-1">
                            The Ultimate Guide to Traveling When You Have No
                            Money
                        </h3>
                        <p class="mt-3 text-gray-500">
                            Embark on a budget-friendly adventure is not just
                            about saving money, It's about maximizing your
                            experiences. By adopting a thrifty mindset
                        </p>
                    </div>
                    <hr class="ml-5 mr-5">
                    <div class="w-full relative flex justify-start items-center flex-wrap gap-5 mt-3 px-4">
                        <button class="group py-2 px-2 uppercase hover:text-primary-500 font-semibold">
                            <span class="group-hover:text-primary-500 transition ease-out duration-500">
                            </span
                            >
                            Read More
                            <mat-icon class="icon-size-5 text-black ml-2 pt-2 group-hover:text-primary-500" [svgIcon]="'feather:arrow-right'"></mat-icon>
                        </button>
                    </div>
                </fuse-card>
            </div>
        </div>
    </div>
</section>
